import { UPDATECUSTOMERSTATUS_FAIL, UPDATECUSTOMERSTATUS_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const updateCustomerStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATECUSTOMERSTATUS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATECUSTOMERSTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateCustomerStatusReducer;
